import { CreateResqlExpertSubmissionRequest } from 'utils/api/resqlexpert.d';

export interface SubmissionFormValues {
  title: string;
  school_id?: number;
  situation_description: string;
  information_sources: string[];
  actions_taken: string;
  involved_parties: string[];
  positive_outcomes: string;
  negative_outcomes: string;
  short_term_objectives: string;
  long_term_objectives: string;
}

export type ValidatedSubmissionFormValues = SubmissionFormValues & { school_id: number };

export const INITIAL_VALUES: SubmissionFormValues = {
  title: '',
  school_id: undefined,
  situation_description: '',
  information_sources: [],
  actions_taken: '',
  involved_parties: [],
  positive_outcomes: '',
  negative_outcomes: '',
  short_term_objectives: '',
  long_term_objectives: '',
};

export const normalize = (
  values: ValidatedSubmissionFormValues,
): CreateResqlExpertSubmissionRequest => ({
  title: values.title.trim(),
  school_id: values.school_id,
  situation_description: values.situation_description.trim() || null,
  actions_taken: values.actions_taken.trim() || null,
  positive_outcomes: values.positive_outcomes.trim() || null,
  negative_outcomes: values.negative_outcomes.trim() || null,
  short_term_objectives: values.short_term_objectives.trim() || null,
  long_term_objectives: values.long_term_objectives.trim() || null,
  information_sources: values.information_sources.map((s) => s.trim()).filter(Boolean),
  involved_parties: values.involved_parties.map((s) => s.trim()).filter(Boolean),
});
